export default async function BAGraficoRelatorio(
    h,
    mediaAgrupadorList,
    metaUsar,
    titulo,
    groupByConfig,
    apontamentos,
    paramsCliente,
    dataInicio,
    dataFim,
    primeiro
) {
    return [
        (primeiro ? "" : h.pageBreak({ pageOrientation: 'portrait' })),
        h.panel(
            [h.row(h.title(titulo, { fontSize: 12 }),),],
            { widths: ["*"], unbreakable: true }
        ),
        h.tablePanel([
            { title: "Agrupador", value: groupByConfig.nome },
            { title: "Meta Cliente", value: metaUsar },
            { title: "Data de Início", value: dataInicio },
            { title: "Data de Fim", value: dataFim },
        ]),
        h.panel(
            [
                h.row(
                    await h.chart(
                        "CardIndicadorProps",
                        {
                            xField: "groupNameShow",
                            yField: "media",
                            data: mediaAgrupadorList,
                            meta: parseFloat(metaUsar),
                            width: 525,
                            height: 400,
                        },
                        { alignment: "center" }
                    )
                ),
            ],
            { widths: ["*"], unbreakable: true, layout: "borders" }
        ),
        h.tablePanel(
            [
                { title: groupByConfig.nome, field: "groupNameShow" },
                { title: "Média", field: "media" },
                { title: "Status", field: "status" },
                {
                    title: "Índice", field: "", getValue: () => {
                        if (mediaAgrupadorList[0].media >= metaUsar) {
                            return "Sim"
                        } else if (mediaAgrupadorList[0].media < metaUsar) {
                            return "Não"
                        } else {
                            return ""
                        }
                    }
                },
            ],
            mediaAgrupadorList
        ),
    ]
}